import { configureStore } from '@reduxjs/toolkit'

import { projectsApi } from 'client/store/projects/projectsApi'
import { storyApi } from 'client/store/story/storyApi'

export const store = configureStore({
  reducer: {
    [projectsApi.reducerPath]: projectsApi.reducer,
    [storyApi.reducerPath]: storyApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(projectsApi.middleware, storyApi.middleware)
  },
})
